import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, catchError, tap } from 'rxjs/operators';

export interface IAuthInterceptorService {
  getIdToken(): Promise<string>;
  idToken: string;
  SignOut(): void;
}

// NOTE: Do NOT inject or provide this class directly. Only extend it in your app-specific interceptors.
export class BaseAuthInterceptor<T extends IAuthInterceptorService> implements HttpInterceptor {
  protected auth: T;
  constructor(auth: T) {
    this.auth = auth;
  }

  protected onForbiddenError(err: any): void {
    this.auth.SignOut();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      req.url.includes('localhost') ||
      // 192.168.1.87
      req.url.includes('192.168.1.87') ||
      req.url.includes('care4giver') ||
      req.url.includes('webhook') ||
      req.url.includes('prod-api')
    ) {
      return from(this.auth.getIdToken()).pipe(
        switchMap(token => {
          if (token) {
            req = req.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
            });
          }
          return next.handle(req);
        }),
        catchError(error => {
          console.error('[BaseAuthInterceptor] Error getting fresh token:', error);
          if (this.auth.idToken) {
            req = req.clone({
              setHeaders: { Authorization: `Bearer ${this.auth.idToken}` },
            });
          }
          return next.handle(req);
        }),
        tap(
          event => {},
          err => {
            if (err.status === 403) {
              console.warn('[BaseAuthInterceptor] 403 error - token may be expired:', err);
              this.onForbiddenError(err);
            }
          }
        )
      );
    }
    return next.handle(req).pipe(tap(
      event => {},
      err => {
        if (err.status === 403) {
          console.warn('[BaseAuthInterceptor] 403 error:', err);
          this.onForbiddenError(err);
        }
      }
    ));
  }
}
